<template>
  <!-- Parent must implement triggerHelp(show) function -->
  <!-- Modal using as a popup containing an help text -->
    <div v-if="show" id="cover"></div>
    <div v-on:click="dismiss()" v-bind:class="(show)? 'showModal noFade' : 'modal fade'" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modalDialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{title}}</h5>
          </div>
          <div class="modal-body">
            {{text}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" v-on:click="dismiss()">{{pageText.button[selectedLang]}}</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'HelpPopup',
  components : {},
  props : {
    show : Boolean,
    title : String,
    text : String,
    selectedLang : String
  },
  methods : {
    dismiss(){
      this.$parent.triggerHelp(false);
    }
  },
  data () {
    return {
      pageText : {
        button : {
          en : "Thanks !",
          fr : "Merci !",
          nl : "Dank U !"
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Overriding bootstrap modal effects to show modal popup */

#cover{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  background-color: black;
  opacity: 0.7;
}

.showModal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1055;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}

.noFade:not(.modalDialog) {
    opacity: 1;
}

.modal-title {
  text-align: center;
  width: 100%;
}

.modalDialog {
  width: 60%;
  margin-right: auto;
  margin-left: auto;
  margin-top: 10vh;
  opacity: 1 !important;
}

@media screen and (max-width: 600px) {
  .modalDialog {
  width: 90%;
}
}

</style>
